var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flip-reveal-container",class:{ flipped: _vm.flipped }},[_c('div',{staticClass:"flipper"},[_c('div',{staticClass:"front"},[_vm._t("default")],2),_c('div',{staticClass:"back"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }